import React, { useState } from "react";
import { Card as MuiCard, Box, Typography, useTheme, useMediaQuery, Button } from "@mui/material";
import LazyLoad from "react-lazyload";
import { useTranslation } from "react-i18next";

const GameCardV2 = ({ imageUrl, imageWidth, onClick, title, isHotGame, alt }) => {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const [isHovered, setHover] = useState(false);
  const { t } = useTranslation();

  return (
    <MuiCard
      variant="outlined"
      sx={{
        cursor: "pointer",
        backgroundColor: "transparent",
        border: 0,
        borderRadius: 2,
        width: imageWidth,
      }}
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          aspectRatio: "1 / 1",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {isHotGame && (
          <Box
            component="img"
            src="/assets/img/hotbanner.png"
            alt="Hot"
            sx={{
              position: "absolute",
              zIndex: 3,
              width: "65%",
              height: "65%",
              top: "-5%",
              left: "-5%",
            }}
          />
        )}

        <LazyLoad>
          {/* Wrapper so LazyLoad receives a single child */}
          <Box sx={{ position: "absolute", inset: 0 }}>
            {/* Blurred fill — covers letterbox areas for non-square images (landscape or portrait) */}
            <Box
              component="img"
              src={imageUrl}
              aria-hidden="true"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                filter: "blur(12px)",
                transform: "scale(1.2)",
                opacity: isHovered ? 0.15 : 0.85,
                transition: "opacity 0.3s ease",
              }}
            />

            {/* Main image — objectFit contain so nothing is cropped */}
            <Box
              component="img"
              src={imageUrl}
              alt={alt}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "contain",
                opacity: isHovered ? 0.3 : 1,
                transition: "opacity 0.3s ease",
                zIndex: 1,
              }}
            />
          </Box>
        </LazyLoad>

        {isHovered && !mobileView && (
          <Button
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundImage: "url(/assets/img/red_small.png)",
              backgroundSize: "100% 100%",
              backgroundRepeat: "no-repeat",
              backgroundColor: "transparent",
              color: "white",
              fontWeight: "bold",
              fontSize: 12,
              whiteSpace: "nowrap",
              zIndex: 4,
              px: 2,
              py: 0.5,
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            {t("home.playNow")}
          </Button>
        )}
      </Box>

      {title && (
        <Typography
          color={process.env.REACT_APP_COLOR_TEXT || "white"}
          fontWeight={500}
          sx={{
            fontSize: { xs: 11, md: 12 },
            pt: 0.5,
            pl: "2px",
            wordBreak: "break-word",
          }}
        >
          {title}
        </Typography>
      )}
    </MuiCard>
  );
};

export default GameCardV2;
